import * as yup from "yup";

const nameValidation = yup.string().required("validation.name_required");

export default nameValidation;
